class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.hoverTimeout = null;
    this.isHovering = false;
    
    // Add hover listeners
    this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
  }

  onMouseEnter() {
    this.isHovering = true;
    clearTimeout(this.hoverTimeout);
    
    // Open with a slight delay for better UX
    this.hoverTimeout = setTimeout(() => {
      if (this.isHovering && !this.mainDetailsToggle.open) {
        this.open();
      }
    }, 150);
  }

  onMouseLeave() {
    this.isHovering = false;
    clearTimeout(this.hoverTimeout);
    
    // Close with a delay to allow moving to submenu
    this.hoverTimeout = setTimeout(() => {
      if (!this.isHovering && this.mainDetailsToggle.open) {
        this.close();
      }
    }, 300);
  }

  open() {
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
    
    // Animate opening
    this.animateContent(true);
  }

  close() {
    // Animate closing
    this.animateContent(false).then(() => {
      this.mainDetailsToggle.removeAttribute('open');
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
    });
  }

  animateContent(isOpening) {
    const content = this.content;
    
    if (isOpening) {
      // Opening animation
      return content.animate([
        { 
          opacity: 0, 
          transform: 'translateY(-10px)',
          maxHeight: '0px'
        },
        { 
          opacity: 1, 
          transform: 'translateY(0)',
          maxHeight: '500px'
        }
      ], {
        duration: 300,
        easing: 'ease-out',
        fill: 'forwards'
      }).finished;
    } else {
      // Closing animation
      return content.animate([
        { 
          opacity: 1, 
          transform: 'translateY(0)',
          maxHeight: '500px'
        },
        { 
          opacity: 0, 
          transform: 'translateY(-10px)',
          maxHeight: '0px'
        }
      ], {
        duration: 200,
        easing: 'ease-in',
        fill: 'forwards'
      }).finished;
    }
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);